/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class NamedParameter {
    getFixupPrototypeFunction() { return NamedParameter.fixupPrototype; }

    static newInstance(model: Partial<NamedParameter>): NamedParameter {
        let obj = Object.assign(new NamedParameter(), model);
        NamedParameter.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<NamedParameter>): NamedParameter {
        if (!model) return null;
        return NamedParameter.newInstance(<NamedParameter> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: NamedParameter) {
        if (!obj) return;

        models.NamedParameter.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: NamedParameter): boolean {
        Object.setPrototypeOf(obj, NamedParameter.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.schema) {
            models.ParameterBase.fixupPrototype(this.schema);
        }
    }

    /**
     * Name of the parameter
     */
    name: string;

    /**
     * Display Name of the parameter
     */
    display_name: string;

    /**
     * Whether the parameter is required.
     */
    is_required: boolean;

    schema: models.ParameterBase;

}
